import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog'
import { ManikLoaderComponent, ManikDataLoaderComponent, ManikAutoCompleteLoader } from '../manik-library/manik-loader/manik-loader.component';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HttpRequestInterceptor } from '../manik-library/manik.authguard';
//import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
@NgModule({
  declarations: [
    ManikLoaderComponent,
    ManikDataLoaderComponent,
    ManikAutoCompleteLoader
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCRNkCEhDvjxASZD11b_PRPZ45VVNdNQZ0'
    }),
    MatDialogModule,
    MatAutocompleteModule,
    MatListModule,
    MatSelectModule,
    MatSidenavModule,
    MDBBootstrapModule.forRoot(),
    //AgmSnazzyInfoWindowModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AgmCoreModule,
    MatIconModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatListModule,
    MatSelectModule,
    ManikLoaderComponent,
    ManikDataLoaderComponent,
    ManikAutoCompleteLoader,
    MatSidenavModule,
    MDBBootstrapModule,
    //AgmSnazzyInfoWindowModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true }]

})
export class SharedModule { }
